// Route-owned account controls. Keeping this inside the page flow avoids
// overlaying editor UI and lets each screen place it where it belongs.

import { useAuth, useNavigate } from "../contexts/AppContext";

export function UserMenu({
  compact = false,
  showAccount = true,
}: {
  compact?: boolean;
  showAccount?: boolean;
}) {
  const { auth, logout } = useAuth();
  const navigate = useNavigate();
  const email = auth.status === "authed" ? auth.email : "";

  return (
    <div
      class={`rounded-3 border bg-body-tertiary p-3 ${compact ? "" : "shadow-sm"}`}
    >
      <div
        class={`d-flex gap-3 ${compact ? "flex-column align-items-start" : "flex-column flex-md-row align-items-md-center justify-content-between"}`}
      >
        <div class="min-w-0">
          <div
            class="text-uppercase text-body-secondary fw-semibold"
            style={{ fontSize: "0.7rem", letterSpacing: "0.08em" }}
          >
            Signed in
          </div>
          <div class="fw-medium text-break">{email}</div>
        </div>
        <div class="d-flex flex-wrap gap-2">
          {showAccount && (
            <button
              type="button"
              class="btn btn-sm btn-outline-secondary"
              onClick={() => navigate("/account")}
            >
              <i class="bi bi-person-circle me-1"></i>Account
            </button>
          )}
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            onClick={logout}
          >
            <i class="bi bi-box-arrow-right me-1"></i>Log out
          </button>
        </div>
      </div>
    </div>
  );
}
